import { routesO } from '../../routes';
import appStoreBadge from '../../../assets/appStoreBadge.png';
import googlePlayBadge from '../../../assets/googlePlayBadge.png';
import phoneWithApp from '../../../assets/phoneApp.png';
import acessaLogo from '../../../assets/logo.png';
import acessaWhiteLogo from '../../../assets/logo_branco.png';
import syngentaWhiteLogo from '../../../assets/syngenta_branco.png';

const STRINGS = {

  // ---------------- General -------------------------------------------------------------------------

  POINT: 'pt',
  POINTS: 'pts',
  POINT_POS: 'suffix',
  POINT_DECIMAL: 0,

  LEVEL: 'nível',
  LEVELS: 'níveis',

  BACK: 'Voltar',
  CONTINUE: 'Continuar',
  LOAD_MORE: 'Carregar mais',
  DOWNLOAD: 'Baixar',
  USER_CONSULTANT_EXISTS:'O Acessa Agro é a plataforma destinada aos agricultores. A nova plataforma para consultores é o Deu Cash.',
  NOT_SHOW_MESSAGE_AGAIN: 'Não mostrar mais essa mensagem.',

  // ---------------- Form ----------------------------------------------------------------------------

  form: {
    label: {
      USERNAME: 'Usuário (CPF ou CNPJ)',
      USERNAME_TEXT: 'Usuário',
      EMAIL: 'E-mail',
      EMAIL_REQUIRED: 'E-mail *',
      USER_CATEGORY: 'Perfil *',
      USER_CULTURAS: 'Culturas',
      NAME: 'Nome *',
      FIRST_NAME: 'Nome *',
      LAST_NAME: 'Sobrenome *',
      COMPANY_NAME: 'Razão Social *',
      STREET: 'Rua *',
      DISTRICT: 'Bairro *',
      CEP: 'CEP *',
      STATE: 'Estado *',
      CITY: 'Cidade *',
      ADDRESSNUMBER: 'Número *',
      COMPLEMENT: 'Complemento',
      PASSWORD: 'Senha *',
      CONFIRM_PASSWORD: 'Confirme a senha *',
      CURRENT_PASSWORD: 'Senha atual',
      NEW_PASSWORD: 'Nova senha',
      NEW_CONFIRM_PASSWORD: 'Confirme sua nova senha',
      BIRTH_DATE: 'Nascimento (dd/mm/aaaa) *',
      CPF: 'CPF/CNPJ *',
      REASON: 'Motivo *',
      TYPE: 'Tipo *',
      SUBJECT: 'Assunto *',
      DESCRIPTION: 'Descrição *',
      ATTACHMENT: 'Anexo',
      PHONE: 'Celular *',
      PROMO_CODE: 'Código do amigo ou promocional',
      STATUS: 'Status',
      TERMS_AND_PRIVACY: `Estou de acordo com os <a href="${routesO.terms.path}" target="_blank">Termos de Uso</a>.`,
      TERMS_AND_PRIVACY_LINKLESS: `Estou de acordo com os Termos de Uso.`,
      SEND: 'Enviar',
      NEXT: 'Avançar',
      VALIDATE: 'Validar',
      SAVE: 'Salvar',
      BACK_TO_TOP: 'Voltar ao topo',
      REFERRAL_CODE_USED: 'Código de Indicação (Opcional)',
      RG: 'RG*',
      PIS: 'PIS*',
      ENDERECO: 'Endereço*'
    },

    message: {
      GENERIC_ERROR: 'Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.',
      USER_NOT_AUTHORIZED: 'Usuário não autenticado. Por favor, faça login para continuar.',
      USER_NOT_FOUND: 'Usuário não encontrado',
      NO_UID: 'Não foi possível identificar o usuário. Por favor, recarregue a página e tente novamente.',
      USER_CANT_LOGIN: 'Não foi possível fazer login. Por favor, tente novamente mais tarde.',
      FORGOT_PASSWORD_SUCCESS: 'Enviamos um e-mail com instruções para redefinir sua senha.',
      DATA_IS_SAVED: 'Seus dados foram salvos.',
      PASSWORD_CHANGE_SUCCESS: 'Sua senha foi alterada.',
      PASSWORD_DEFINE_SUCCESS: 'Sua senha foi definida.',
      ACCESS_CODE_REVALIDATION_IS_NEEDED: 'É necessário revalidar seu código de acesso.',
      ACCESS_CODE_NO_PHONE_AND_EMAIL: `Seu cadastro não possui telefone e e-mail. Por favor, <a href="${routesO.caseNew.path}" target="_blank">entre em contato conosco.</a>`,
      NO_PERMISSION_TO_ACCESS_PAGE: 'Você não possui permissão para acessar esta página.',
      USER_IS_DISABLED: 'Conta desabilitada. Por favor, entre em contato para mais informações.',
      USER_IS_INACTIVE_OR_BLOCKED: 'Não foi possível fazer login pois o usuário está inativo ou bloqueado.',
      PASSWORD_CHANGE_SUCCESS_OKTA_SSO: 'Sua senha foi alterada. Lembre-se que essa será a mesma senha utilizada em outras plataformas da Syngenta.'
    },

    validation: {
      RECAPTCHA_TOKEN_INVALID: 'Token inválido. Atualize sua página!',
      RECAPTCHA_TOKEN_ERROR: 'Erro ao validar o token. Atualize a sua página!',
      USER_OR_PASSWORD_INVALID: 'Usuário ou senha inválidos.',
      EMPTY_USERNAME: 'Digite um CPF ou CNPJ',
      USED_USERNAME: 'Este usuário já está em uso',
      OKTA_EMAIL_USED: 'Este e-mail já esta vinculado a outra conta Okta. Por favor, utilize outro e-mail.',
      OKTA_CHECK_EMAIL_FAIL: 'Não foi possível validar o uso desse e-mail. Por favor, tente novamente.',
      INVALID_USERNAME: 'Digite um CPF ou CNPJ válidos',
      EMPTY_EMAIL: 'Digite um e-mail',
      INVALID_EMAIL: 'Digite um endereço de e-mail válido',
      USED_EMAIL: 'Este e-mail já está em uso',
      EMPTY_PASSWORD: 'Digite sua senha',
      NEW_EMPTY_PASSWORD: 'Digite sua nova senha',
      EMPTY_CONFIRM_PASSWORD: 'Digite a confirmação da senha',
      IDENTICAL_PASSWORD: 'A senha e confirmação devem ser idênticas',
      INVALID_PASSWORD: 'Senha inválida',
      WRONG_PASSWORD: 'Não foi possível realizar login, sua senha está incorreta.',
      INVALID_PASSWORD_COMPOSITION: 'Senha não possui os requisitos mínimos especificados',
      WEAK_PASSWORD: 'Senha precisa ter pelo menos 8 caracteres',
      EMPTY_TERMS_CHECKBOX: 'Marque a caixa de seleção para continuar',
      EMPTY_CPF: 'Digite seu CPF',
      EMPTY_RG: 'Digite seu RG',
      EMPTY_PIS: 'Digite seu PIS',
      ALL_EQUAL_PIS: 'Os números do seu PIS não podem ser todos iguais.',
      ALL_EQUAL_RG: 'Os números do seu RG não podem ser todos iguais.',
      EMPTY_ENDERECO: 'Digite seu endereço',
      EMPTY_CPFCNPJ: 'Digite seu CPF ou CPNJ',
      INVALID_CPFCNPJ: 'Digite um CPF ou CNPJ válido',
      INVALID_CPF: 'Digite um CPF válido',
      INVALID_RG: 'Digite um RG válido',
      USED_CPF: 'Este CPF já está cadastrado',
      USED_CPFCNPJ: 'Este CPF/CNPJ já está cadastrado',
      EMPTY_BIRTH_DATE: 'Digite a data de nascimento',
      INVALID_DATE: 'Digite uma data válida',
      EMPTY_FIRST_NAME: 'Digite seu nome',
      EMPTY_LAST_NAME: 'Digite seu sobrenome',
      INVALID_FIRST_NAME: 'O nome deve ser formado por letras. Mínimo 3 caracteres.',
      INVALID_LAST_NAME: 'O sobrenome deve ser formado por letras. Mínimo 3 caracteres.',
      EMPTY_COMPANY_NAME: 'Digite a razão social',
      INVALID_COMPANY_NAME: 'A razão social deve ser formada por letras. Mínimo 3 caracteres.',
      EMPTY_NAME: 'Digite seu nome',
      EMPTY_PHONE: 'Digite seu número de celular',
      INVALID_PHONE: 'Digite um número de celular com DDD válido',
      EMPTY_USER_CATEGORY: 'Escolha um',
      INVALID_PROMO_CODE: 'Código promocional inválido',
      EMPTY_TYPE: 'Escolha um tipo',
      EMPTY_SUBJECT: 'Digite um assunto',
      EMPTY_REASON: 'Escolha um motivo',
      EMPTY_DESCRIPTION: 'Digite uma descrição',
      EMPTY_EMAIL_AND_PHONE: 'Telefone ou endereço de e-mail são obrigatórios',
      EMPTY_POSITION: 'Escolha um cargo',
      EMPTY_STATUS: 'Escolha um status',
      EMPTY_STATE: 'Escolha um estado',
      EMPTY_CITY: 'Escolha uma cidade',
      INVALID_ZIPCODE: 'CEP inválido',
      EMPTY_PHOTO: 'Envie uma foto',
      RECORD_TYPE_ERROR: 'Erro ao buscar record-Type',
      INVALID_REFERRAL_CODE: 'Código de indicação inválido',
      EMPTY_CEP: 'Informe o CEP',
      EMPTY_STREET: 'Informe a rua',
      EMPTY_NUMBER: 'Informe o número',
      EMPTY_DISTRICT: 'Informe o bairro'
    },

    passwordTips: {
      CHARS: 'No mínimo {QTY} caracteres',
      LOWERCASE: 'No mínimo {QTY} letra minúscula (a-z)',
      UPPERCASE: 'No mínimo {QTY} letra maiúscula (A-Z)',
      NUMBER: 'No mínimo {QTY} número (0-9)',
      SYMBOL: 'No mínimo {QTY} símbolo',
    },
  },

  // ---------------- Components ----------------------------------------------------------------------

  components: {
    accessCode: {
      TITLE: 'Código de Acesso',
      CODE_SENT: 'Enviamos um código de acesso',
      CODE_SENT_TRANSFER: 'Para confirmação da sua transferência, enviamos um código de validação',
      CODE_SENT_TO_PHONE: '- Via SMS ou WHATSAPP para seu celular <b>de final {PHONE_HINT}</b>',
      CODE_SENT_TO_EMAIL: '- Em seu e-mail <b>{EMAIL_HINT}</b>',
      SPAM_REMINDER: 'Lembre-se de verificar sua caixa de spam.',
      TYPE_CODE: 'Por favor, informe o código recebido:',
      PHONE_OR_EMAIL_UNRECOGNIZED: 'Caso não reconheça o e-mail ou telefone, fale com a gente!',
      NEW_CASE_TYPE: 'Solicitação',
      NEW_CASE_REASON: 'Correção de e-mail e/ou telefone',
      RESEND_CODE: 'Reenviar código',
      SENT_NEW_CODE_MESSAGE: 'Enviamos um novo código de acesso para você.',
      SENT_NEW_CODE_MESSAGE_TRANFER: 'Enviamos um código de validação para você.',
      INVALID_CODE: 'Código inválido!',
      CANT_VALIDATE_CODE: 'Impossível validar código. Tente novamente mais tarde.',
      VALIDATED_NOTIFICATION_TITLE: 'Tudo certo',
      VALIDATED_NOTIFICATION_MESSAGE: 'Seu código de acesso foi validado',
      VALIDATED_NOTIFICATION_MESSAGE_TRANSFER: 'Seu código foi validado',
      LOADING_MESSAGE: 'Enviando o código de acesso...<br/>Por favor, aguarde.',
      LOADING_MESSAGE_TRANSFER: 'Você irá receber um código de validação<br/>Para realizar a transferênca...<br/>Por favor, aguarde.',
      CANT_SEND_CODE: 'Ocorreu um erro ao enviar o código de acesso.',
      CANT_SEND_CODE_TRANSFER: 'Ocorreu um erro ao enviar o código de validação.',
    },
    socialLogin: {
      OR: 'OU',
      ACCESS_USING: 'Acesse usando',
    },
    challenge: {
      SECTION_TITLE: 'Complete os desafios para pontuar',
      SECTION_LINK: 'VER TODOS OS DESAFIOS',
      LIST_TITLE: 'Desafios',
      LIST_DESCRIPTION: 'Complete os desafios para ganhar pontos!',
      LIST_BUTTON: 'Ver detalhes',
      LIST_BANNER: 'Os pontos não acabam aqui. Conheça também os <b>ACELERADORES</b>!',
    },
    howToEarn: {
      SECTION_TITLE: 'Com aceleradores, você acumula mais rápido!',
      SECTION_LINK: 'Ver todos',
      LIST_TITLE: 'Aceleradores',
      LIST_BANNER: 'Os pontos não acabam aqui. Conheça também os <b>DESAFIOS</b>!',
    },
    premmiarVitrine: {
      SECTION_TITLE: 'Troque seus pontos por produtos, serviços e muito mais!',
      SECTION_LINK: 'Acessar o catálogo completo',
      ERROR_WAITING_FOR_REGISTRATION: 'Seu cadastro ainda está em processamento na plataforma de premiação. Por favor, tente novamente mais tarde.',
      ERROR_INCOMPLETE_PROFILE: 'Para acessar a plataforma de premiação, é necessário complementar seu perfil',
      ERROR_UNKNOWN: 'Ocorreu um erro inesperado ao acessa a plataforma de premiação. Por favor, tente novamente em 15 minutos e se o erro persistir entre em contato com nossa central de atendimento.',
    },
    filter: {
      TITLE: 'Filtros',
      APPLY: 'Aplicar',
    },
    reward: {
      LIST_TITLE: 'Prêmios',
      LIST_DESCRIPTION: 'Troque seus pontos por prêmios',
      LIST_BANNER: 'Quer ganhar mais pontos? Conheça os <b>ACELERADORES</b>!',
      NO_RESULTS_TITLE: 'Nenhum resultado encontrado :(',
      NO_RESULTS_MESSAGE: 'Por favor, altere os filtros e tente novamente',
      SECTION_TITLE: 'Troque seus pontos por prêmios',
      SECTION_LINK: 'VER TODOS OS PRÊMIOS',
      REWARD_CONFIRMATION_MESSAGE: 'Deseja realmente resgatar <b>{QTY}x {REWARD_NAME}</b> por <b>{REWARD_TOTAL_POINTS} {POINTS_LABEL}</b>?',
      REDEEM_BUTTON: 'Resgatar',
      QUANTITY: 'Quantidade:',
      TYPE: 'Tipo:',
      BALANCE: 'Saldo:',
      SUCCESS_MESSAGE: '<b>Prêmio resgatado!</b><br/>Em breve, você receberá um e-mail com mais instruções para efetivar o resgate.',
      ERROR_MESSAGE: '<b>Não foi possível fazer o resgate.</b><br/>Por favor, tente novamente mais tarde.',
      LOADING_TEXT: 'Processando',
      MILESTONE_REWARD_LIST: 'Lista de prêmios',
    },
    results: {
      RESULTS_LABELS: {
        Released: 'Premiação antecipada',
        'forecast': 'Previsão de premiação',
        'anticipation': 'Premiação antecipada'
      }
    },
    news: {
      LIST_TITLE: 'Notícias',
      SECTION_TITLE: 'Notícias',
      SECTION_LINK: 'VER MAIS NOTÍCIAS',
      CATEGORY_LABELS: {
        Youtube: 'Vídeos',
        News: 'Eventos',
        Training: 'Treinamentos',
      },
    },
    campaigns: {
      CATEGORY_LABELS: {
        Vigentes: 'Vigentes',
        Encerradas: 'Encerradas'
      }
    },
    points: {
      CATEGORY_LABELS: {
        Statement: 'Extrato',
        DueDate: 'Pontos à vencer',
      },
    },
    game: {
      ABOVE_CATEGORY_TEXT: '{LEVEL_LABEL} Atual',
      BOX_POINTS_TEXT: '{POINTS_LABEL} disponíveis',
      BOX_MOBILE_POINTS_TEXT: 'Você já conquistou <b>{CURRENT_POINTS}</b> {POINTS_LABEL}',
      NEXT_LEVEL: 'Ganhe <b>{POINTS_TO_LEVEL}</b> {POINTS_LABEL} para alcançar o {LEVEL_LABEL} {LEVEL}',
      NEXT_LEVEL_2: 'Faltam <b>{POINTS_TO_LEVEL}</b> {POINTS_LABEL} para alcançar este {LEVEL_LABEL}',
      AVAILABLE_REWARD: '1 prêmio disponível!',
      AVAILABLE_REWARDS: '{QTY} prêmios disponíveis!',
      SHOW_REWARDS: '<i class="fa fa-trophy"></i> Conheça os prêmios',
      YOUR_LEVEL: 'Seu nível',
      YOUR_PROGRESS: 'Seu progresso',
      CURRENT_BENEFITS: 'Benefícios atuais',
      OTHER_BENEFITS: 'Benefícios {LEVEL}',
      REACHED_LEVEL: 'Você alcançou este nível!',
      STATEMENT: 'Extrato',
      BALANCE: 'Saldo',
      BALANCE_HINT: 'É o balanço final de pontos, entre créditos e débitos, disponíveis para resgate de prêmios',
      QUALIFYING_POINTS: 'Pontos Acumulados',
      QUALIFYING_POINTS_HINT: 'É o total de pontos adquiridos nesta temporada que definem sua classificação',
    },
    survey: {
      list: {
        survey: {
          TITLE: 'Pesquisas',
          NO_RESULTS_TITLE: 'Todas as pesquisas respondidas!',
          NO_RESULTS_MESSAGE: 'Volte mais tarde para mais pesquisas',
          IS_DONE: '(Já respondida)',
        },
        quiz: {
          TITLE: 'Quiz',
          NO_RESULTS_TITLE: 'Todos os quizzes respondidos!',
          NO_RESULTS_MESSAGE: 'Volte mais tarde para mais quizzes',
          IS_DONE: '(Já respondido)',
        },
      },
      play: {
        TIP_MAX_OPTIONS: 'Escolha até {VALUE} opções.',
        TIP_MIN_NUMBER: 'Valor mínimo: {VALUE}.',
        TIP_MAX_NUMBER: 'Valor máximo: {VALUE}.',
        SEND: 'Enviar &nbsp; <i class="fa fa-chevron-right"></i>',
        SENDING: 'Enviando...',
        SKIP: 'Pular &nbsp; <i class="fa fa-child"></i>',
        NEXT_QUESTION: 'Próxima pergunta',
        END_OF_QUIZ: 'Fim do quiz',
        TIMER: 'em {VALUE}s...',
        CORRECT: 'Certa resposta!',
        WRONG: 'Que pena, você errou!',
      }
    },
    notification: {
      TITLE: 'Notificações',
      NOTIFICATIONS_DENIED_TITLE: 'Não foi possível ativar notificações',
      NOTIFICATIONS_DENIED_MESSAGE: 'Não foi possível obter permissão para receber notificações.',
    },
    case: {
      SECTION_TITLE: 'Fale Conosco',
      LIST_TITLE: 'Meus Chamados',
      DETAIL_TITLE: 'Detalhes do Chamado',
      NEW_TITLE: 'Fale Conosco',
      NEW_DESCRIPTION: 'A Syngenta quer te ouvir.<br/>Deixe aqui suas dúvidas ou sugestões',
      BACK_TO_CASE_LIST: '<i class="fa fa-chevron-left"></i> &nbsp; Voltar à lista de chamados',
      CASE_MESSAGE_PROCESS: 'Seu contato está em análise. Retornaremos em breve.',
      CASE_PROCESS: 'Em Análise',
      CASE_CLOSED: 'Fechado',
      CASE_OPEN: 'Novo',
    },
    appAd: {
      TITLE: 'Baixe o App Acessa Agro<br/>e aproveite as ofertas',
      DESCRIPTION: 'Com o app do Acessa Agro,<br/>você consulta seu saldo,<br/>resgata benefícios e fica por<br/>dentro das promoções.<br/>Tudo sempre à mão!',
      LINKS_DESCRIPTION: 'Tenha seus pontos sempre à mão!',
      GOOGLE_PLAY_ALT: 'Disponível no Google Play',
      APP_STORE_ALT: 'Disponível na App Store',
    },
    widget: {
      SECTION_TITLE: 'Fique por dentro do clima e dos preços das culturas',
    },
    easy: {
      SECTION_TITLE: 'VEJA COMO É FÁCIL GANHAR',
    },
    picBlock: {
      SECTION_TITLE: 'O Acessa Agro oferece um catálogo completo para atender o seu negócio',
    },
  },

  // ---------------- Screens -------------------------------------------------------------------------

  screen: {
    gamefication:{
      USER_CONTACT_NOT_FOUNT: 'Ops! Nenhum contato encontrado!',
      TRANSFER_POINTS_ONLY_FARMERS: 'As transferências podem ser feitas apenas entre agricultores!',
      TRANSFER_POINTS_ONLY_PARTICIPANTS_FARMERS: 'Apenas participantes produtores podem receber transferências de pontos!',
      UNKNOW_ERROR: 'Não foi possível concluir sua solicitação. Tente novamente em alguns instantes.'
    },
    forgotPassword: {
      TITLE: 'Recuperar Senha',
      BACK_TO_LOGIN: 'Voltar para login',
    },

    login: {
      TITLE: 'Seja bem-vindo!',
      FORGOT_PASSWORD_LINK: 'Esqueceu a senha?',
      BEFORE_SIGN_UP_LINK: 'Não é cadastrado? ',
      SIGN_UP_LINK: 'Cadastre-se',
    },

    signUp: {
      TITLE: 'Criar Conta',
      BACK_TO_LOGIN: 'Voltar para login',
      SEND_TO_SIGNUP_FULL: 'Próxima',
      ACCOUNT_OKTA_EXISTS: 'Identificamos que esse CPF/CNPJ já está cadastrado em outras plataformas da Syngenta. Para validarmos o seu uso nessa plataforma, enviaremos um e-mail com um código de acesso.',
    
    
    },

    signUpFull: {
      TITLE: 'Completar Cadastro',
    },

    termsAgreement: {
      TITLE: 'Aviso de Atualização',
      FIRST_DESCRIPTION: 'Gostaríamos de compartilhar que os termos e condições da plataforma foram atualizados.',
      SECOND_DESCRIPTION: 'Pedimos que leia com atenção os termos e siga os passos para continuar aproveitando todos os benefícios que o Programa Acessa Agro oferece para você.',
      ACCEPT_LATER: 'Aceitar mais tarde',
      ACCEPT_NOW: 'Aceitar agora'
    },

    campaignsAgreement: {
      DESCRIPTION: 'Estou de acordo com o regulamento da campanha',
      ACCEPT: 'Participar'
    },

    profile: {
      TITLE: 'Editar Perfil',
    },

    changePassword: {
      TITLE: 'Alterar Senha',
    },

    definePassword: {
      TITLE: 'Definir Senha',
      DESCRIPTION: 'É necessário definir uma nova senha para sua conta',
    },

    referFriend: {
      TITLE: 'Indique e Ganhe',
    },
  },

  // ---------------- URLs ----------------------------------------------------------------------------

  urls: {
    GOOGLE_PLAY_LINK: 'https://play.google.com/store/apps/details?id=br.com.valuenet.syngentaaliado&hl=pt_BR&gl=US',
    APP_STORE_LINK: 'https://apps.apple.com/br/app/acessa-agro/id1441252658',
  },

  // ---------------- Images -------------------------------------------------------------------------

  images: {
    ACESSA_LOGO: acessaLogo,
    ACESSA_WHITE_LOGO: acessaWhiteLogo,
    SYNGENTA_WHITE_LOGO: syngentaWhiteLogo,
    GOOGLE_PLAY_BADGE: googlePlayBadge,
    APP_STORE_BADGE: appStoreBadge,
    PHONE_WITH_APP: phoneWithApp,
  },
}

export default STRINGS;